import $ from 'jquery';
import 'slick-carousel';
import { Component } from '../core/component';

export class ImageGridSlider extends Component {
    constructor() {
        super();
        this.selector = '.image-grid--slider';
    }

    init() {
        /* eslint-disable no-unused-vars */
        this.$elements.each((index, element) => {
            const imageSlider = $(element).find('.lightbox-image-slider').first();
            const customCloseLightbox = imageSlider.next('.lightbox-image-slider__close');
            // All lightboxes defined in element
            const lightbox = $(element).find('.lightbox--image-slider');
            let renderedLightboxWrapper = null;
            /* eslint-disable no-unused-vars */
            lightbox.modaal({
                overlay_opacity: 0.67,
                hide_close: true,
                before_open: (event) => {
                    const imageGridItemId = $(event.currentTarget).attr('id').split('-').pop();
                    imageSlider.slick({
                        initialSlide: +imageGridItemId,
                        dots: false,
                        slidesToShow: 1,
                        autoplay: false,
                        arrows: true,
                        prevArrow: '<button class="slider-prev slick-arrow">'
                            + '<i class="fas fa-chevron-left"></i></button>',
                        nextArrow: '<button class="slider-next slick-arrow">'
                            + '<i class="fas fa-chevron-right"></i></button>',
                    });
                },
                after_open: (modalWrapper) => {
                    renderedLightboxWrapper = modalWrapper;
                },
                after_close: () => {
                    imageSlider.slick('unslick');
                },
            });
            customCloseLightbox.on('click', (e) => {
                e.stopPropagation();
                /* eslint-disable max-len */
                const lightboxTrigger = $(`.lightbox--image-slider[data-modaal-scope='${renderedLightboxWrapper.attr('id')}']`).first();
                lightboxTrigger.modaal('close');
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/imageGridSlider.js